import { useParams } from 'react-router-dom';
import { useActivityLogs } from '../hooks/useFirestoreData';
import { Spinner } from '../components/ui/Spinner';
import { Badge } from '../components/ui/Badge';
import { format } from 'date-fns';

export function ActivityPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const { data: logs, loading } = useActivityLogs(projectId ?? null, 200);

  return (
    <div
      data-testid="activity-page-root"
      className="h-full overflow-auto px-3 py-4 sm:px-6 sm:py-6"
    >
      <h2 className="text-lg font-semibold">アクティビティ</h2>
      {loading ? (
        <div className="mt-8 flex justify-center">
          <Spinner />
        </div>
      ) : logs.length === 0 ? (
        <div className="card mt-6 p-6 text-center text-sm text-slate-600">
          まだアクティビティがありません。
        </div>
      ) : (
        <ol className="mt-4 space-y-2">
          {logs.map((l) => (
            <li key={l.logId} className="card px-3 py-2 text-sm sm:px-4 sm:py-3">
              {/*
               * On mobile we stack the summary above the action / time
               * meta so neither has to truncate; flexbox switches back
               * to a single horizontal row at `sm+`.
               */}
              <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between sm:gap-2">
                <span className="min-w-0 break-words font-medium">
                  {l.summary}
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <Badge tone="slate">{l.action}</Badge>
                  <span className="text-xs text-slate-500">
                    {l.createdAt?.toDate
                      ? format(l.createdAt.toDate(), 'MM/dd HH:mm')
                      : '—'}
                  </span>
                </div>
              </div>
              <div className="mt-1 truncate text-xs text-slate-500">
                by {l.actorUserId}
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
